module.exports = __webpack_public_path__ + "static/media/incomplete2.c2f50dae.jpg";